import { render, staticRenderFns } from "./OrderGiftItem.vue?vue&type=template&id=9fd6ebb8"
import script from "./OrderGiftItem.vue?vue&type=script&lang=js"
export * from "./OrderGiftItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports